import 'reflect-metadata';
import { FilterExpression } from '@progress/kendo-angular-filter';

export function Filterable(options: FilterExpression) {
  return function (target: any, propertyKey: string) {
    Reflect.defineMetadata('filterOptions', options, target, propertyKey);
  };
}
